import { VERIFY_IS_MAINTENANCE } from './constants';

export const verifyIsMaintenance = () => ({
  type: VERIFY_IS_MAINTENANCE,
});
